import {PageBanner} from '@github-ui/custom-properties-core/components/PageBanner'
import {BannerProvider} from '@github-ui/custom-properties-core/context/BannerContext'
import type {PropsWithChildren} from 'react'

export function App({children}: PropsWithChildren) {
  return (
    <BannerProvider>
      <PageBanner className="pr-mb-3" />
      {children}
    </BannerProvider>
  )
}
